// @ts-nocheck
import React from "react";
import SharedSelect from "./SharedSelect";
import { TCG_OPTIONS } from "../constants/tcgOptions";
import "../styles/ListingFiltersBar.css";

type ListingFiltersBarProps = {
  mode: "bounty" | "trade";
  searchValue: string;
  onSearchChange: (value: string) => void;
  zipValue: string;
  onZipChange: (value: string) => void;
  gameValue: string;
  onGameChange: (value: string) => void;
  hidePostalCode?: boolean;
  verifiedOnly: boolean;
  onVerifiedToggle: () => void;
  gradedOnly: boolean;
  onGradedToggle: () => void;
  onClear: () => void;
  canClear: boolean;
};

export default function ListingFiltersBar({
  mode,
  searchValue,
  onSearchChange,
  zipValue,
  onZipChange,
  gameValue,
  onGameChange,
  hidePostalCode = false,
  verifiedOnly,
  onVerifiedToggle,
  gradedOnly,
  onGradedToggle,
  onClear,
  canClear,
}: ListingFiltersBarProps) {
  return (
    <div className="listing-filters-shell">
      <div className="filters-row listing-filters-row">
        <div className="filter-field filter-field-search">
          <label htmlFor={`${mode}FilterSearch`}>Search</label>
          <input
            id={`${mode}FilterSearch`}
            type="text"
            value={searchValue}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Search card name"
          />
        </div>

        <div className="filter-field">
          <label htmlFor={`${mode}FilterGame`}>TCG</label>
          <SharedSelect
            id={`${mode}FilterGame`}
            value={gameValue || "all"}
            onChange={(event) => onGameChange(event.target.value)}
          >
            <option value="all">Any</option>
            {TCG_OPTIONS.map((game) => (
              <option key={game} value={game}>
                {game}
              </option>
            ))}
          </SharedSelect>
        </div>

        {!hidePostalCode && (
          <div className="filter-field">
            <label htmlFor={`${mode}FilterZipCode`}>Postal Code</label>
            <input
              id={`${mode}FilterZipCode`}
              type="text"
              value={zipValue}
              onChange={(event) => onZipChange(event.target.value.slice(0, 16))}
              placeholder="Enter postal code"
              maxLength={16}
            />
          </div>
        )}

        {/*
        <div className="filter-field">
          <label>Verified</label>
          <label className="filter-check-control">
            <input type="checkbox" checked={verifiedOnly} onChange={onVerifiedToggle} />
            <span>Verified traders only</span>
          </label>
        </div>
        */}

        <div className="filter-field">
          <label htmlFor={`${mode}FilterGraded`}>Graded</label>
          <label className="filter-check-control">
            <input
              id={`${mode}FilterGraded`}
              type="checkbox"
              checked={gradedOnly}
              onChange={onGradedToggle}
            />
            <span>Graded only</span>
          </label>
        </div>

        <div className="filter-field filter-action">
          <label>Actions</label>
          <button type="button" className="filters-clear" onClick={onClear} disabled={!canClear}>
            Clear
          </button>
        </div>
      </div>
    </div>
  );
}
